import { apiMap } from '@cloudpivot/api';
import apis from '../../extends/api';
apiMap.assign(apis);
